module.exports = __webpack_public_path__ + "static/media/HTML5_Logo.a3492ddb.svg";